import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import itemSalesReportTemplate from './itemSalesReport.template.html';

export default angular
  .module('books.ui.itemSalesReport', [csmCommonWeb, booksService])
  .directive('itemSalesReport', itemSalesReportDirective).name;

/*******************************************************************************
 * itemSalesReportDirective */
/**
 * Directive for the item sales report.
 *******************************************************************************/
/* @ngInject */ function itemSalesReportDirective(
  BooksSvc,
  BusyScreen,
  SERVER
) {
  return {
    template: itemSalesReportTemplate,
    scope: {
      dateLabel: '@', // Label for the input field on the date dropdown.
      hideReturns: '=' // Boolean. Hides the include returns checkbox when true.
    },
    link: function ($scope, element, attr) {
      /***********************************************************************
       * allProducts */
      /**
       * Checks to see if all products are selected. If so, we will submit null
       * to the request object. This was done because the array will get truncated
       * if there are too many items.
       ***********************************************************************/
      $scope.allProducts = function () {
        if (!$scope.data.products || !$scope.items) return;

        return $scope.data.products.length == $scope.items.length;
      };

      /*------------------------------------*/
      /* Static array of Item Sales options */
      /*------------------------------------*/
      $scope.itemOptions = [
        { name: 'All Sales', code: '' },
        { name: 'Open Orders', code: 'OO' },
        { name: 'Unpaid Items', code: 'UI' },
        { name: 'Web Store', code: 'WS' }
      ];

      /*------------------------*/
      /* Static array of grades */
      /*------------------------*/
      $scope.grades = [
        { label: 'All', id: -1 },
        { label: 15, id: 15 },
        { label: 14, id: 14 },
        { label: 13, id: 13 },
        { label: 12, id: 12 },
        { label: 11, id: 11 },
        { label: 10, id: 10 },
        { label: 9, id: 9 },
        { label: 8, id: 8 },
        { label: 7, id: 7 },
        { label: 6, id: 6 },
        { label: 5, id: 5 },
        { label: 4, id: 4 },
        { label: 3, id: 3 },
        { label: 2, id: 2 },
        { label: 1, id: 1 },
        // The label must be a string for the select to work properly, otherwise it shows up as [Object object]
        { label: '0', id: 0 }
      ];

      /*---------------------*/
      /* Sets default values */
      /*---------------------*/
      $scope.req = {
        reportFormat: 'PDF',
        basicType: '',
        sortByName: false,
        grade: -1,
        includeReturns: false,
        entityType: 0
      };

      $scope.data = {};

      /*-------------------------------------------------*/
      /* Converts the productID array to a string to be  */
      /* submitted in the request. If all products are   */
      /* selected or no product is selected submit null. */
      /*-------------------------------------------------*/
      $scope.$watch('data.products', function (product) {
        $scope.req.productIDs =
          !$scope.allProducts() && product ? product.toString() : null;
      });

      /*--------------------------------------------------*/
      /* Works with the csm Validator to make sure the    */
      /* product field has an item selected and an entity */
      /* name is selected when set to an individual.      */
      /*--------------------------------------------------*/
      $scope.valOption = {};
      $scope.validateInput = function () {
        return $scope.valOption.validate();
      };

      /***********************************************************************
       * getItemClass */
      /**
       * Adds the inactive-content CSS class to items that are not active. If
       * item is not active, no class is added.
       *
       * @param  item  Item to check
       * @return       CSS class to add to item when not active.
       ***********************************************************************/
      $scope.getItemClass = function (item) {
        return !item.active ? 'inactive-content' : '';
      };

      /*-------------------*/
      /* Load initial data */
      /*-------------------*/
      BooksSvc.getOrganization().then(function (resp) {
        $scope.org = resp.data;

        BooksSvc.getProductList(null, false, false, false).then(
          function (resp) {
            var itemsList = resp.data
              .sort(function (a, b) {
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
              })
              .filter(function (p) {
                return p.type != SERVER.BooksDBConstants.IT_DONATION;
              });

            /*--------------------------------------------------*/
            /* Creates a new categories array from the items    */
            /* array to filter the item typeahead based on the  */
            /* category selected in the Item Category typeahead */
            /*--------------------------------------------------*/
            var catIDs = [];
            var categories = [];
            for (var i = 0; i < resp.data.length; i++)
              if (catIDs.indexOf(resp.data[i].categoryID) == -1) {
                catIDs.push(resp.data[i].categoryID);
                categories.push({
                  id: resp.data[i].categoryID,
                  name: resp.data[i].category
                });
              }
            $scope.categories = [
              { categoryID: 0, name: 'All Item Categories' }
            ].concat(categories);

            resp.data.sort(function (a, b) {
              return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });

            /*------------------------------------------------------------*/
            /* Watches the req.categoryID for changes and updates the     */
            /* product dropdown based on the categoryID selected and sets */
            /* the data.products to null upon any change to the category. */
            /*------------------------------------------------------------*/
            $scope.$watch('req.categoryID', function (category) {
              $scope.items = [];
              if (category) {
                for (var j = 0; j < itemsList.length; j++) {
                  if (itemsList[j].categoryID == category) {
                    $scope.items.push(itemsList[j]);
                    $scope.data.products = null;
                  }
                }
              } else if (!category) {
                $scope.items = itemsList;
                $scope.data.products = null;
              }
              return '';
            });
          }
        );
        BusyScreen.setBusy(false);
      });
    }
  };
}
